
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9tTRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e7227c0e5cdec9e$export$2e2bcd8739ae039; });

var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $3UzX5 = parcelRequire("3UzX5");

var $5iIcV = parcelRequire("5iIcV");

var $diw9q = parcelRequire("diw9q");
var $6e7227c0e5cdec9e$var$AsyncSelect = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $5iIcV.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $diw9q.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3UzX5.default), (0, $9RXLj.default)({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e7227c0e5cdec9e$export$2e2bcd8739ae039 = $6e7227c0e5cdec9e$var$AsyncSelect;

});
parcelRegister("9RXLj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72f76bc6dd2b3aff$export$2e2bcd8739ae039; });
function $72f76bc6dd2b3aff$export$2e2bcd8739ae039() {
    return $72f76bc6dd2b3aff$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $72f76bc6dd2b3aff$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3UzX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d927d5b5ec11b72$export$2e2bcd8739ae039; });

var $9RXLj = parcelRequire("9RXLj");
parcelRequire("gdbXW");

var $6cZa1 = parcelRequire("6cZa1");

var $iAnwu = parcelRequire("iAnwu");

var $9P5Ld = parcelRequire("9P5Ld");

var $68nHy = parcelRequire("68nHy");

var $eWqoV = parcelRequire("eWqoV");

var $9cV9f = parcelRequire("9cV9f");

var $5itxH = parcelRequire("5itxH");

var $688hO = parcelRequire("688hO");

var $iSvIT = parcelRequire("iSvIT");

var $aGSwI = parcelRequire("aGSwI");

var $jxLBU = parcelRequire("jxLBU");

var $3NC2H = parcelRequire("3NC2H");

var $9vbt6 = parcelRequire("9vbt6");

var $7WwtK = parcelRequire("7WwtK");
var $e289l = parcelRequire("e289l");
var $5QjDl = parcelRequire("5QjDl");

var $3v0EL = parcelRequire("3v0EL");

var $hx8bc = parcelRequire("hx8bc");

var $fjGa0 = parcelRequire("fjGa0");

var $asdXs = parcelRequire("asdXs");

var $8d2S5 = parcelRequire("8d2S5");

var $gRzS4 = parcelRequire("gRzS4");
function $2d927d5b5ec11b72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d927d5b5ec11b72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d927d5b5ec11b72$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d927d5b5ec11b72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2d927d5b5ec11b72$var$_callSuper(t, o, e) {
    return o = (0, $eWqoV.default)(o), (0, $68nHy.default)(t, $2d927d5b5ec11b72$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $eWqoV.default)(t).constructor) : o.apply(t, e));
}
function $2d927d5b5ec11b72$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2d927d5b5ec11b72$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2d927d5b5ec11b72$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gRzS4.isTouchCapable)(),
    captureMenuScroll: !(0, $gRzS4.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $asdXs.createFilter)(),
    formatGroupLabel: (0, $3NC2H.formatGroupLabel),
    getOptionLabel: (0, $3NC2H.getOptionLabel),
    getOptionValue: (0, $3NC2H.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $3NC2H.isOptionDisabled),
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gRzS4.isMobileDevice)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $2d927d5b5ec11b72$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $2d927d5b5ec11b72$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $2d927d5b5ec11b72$var$_isOptionSelected(props, option, selectValue);
    var label = $2d927d5b5ec11b72$var$getOptionLabel(props, option);
    var value = $2d927d5b5ec11b72$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $2d927d5b5ec11b72$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $2d927d5b5ec11b72$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $2d927d5b5ec11b72$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $2d927d5b5ec11b72$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $2d927d5b5ec11b72$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gRzS4.notNullish));
}
function $2d927d5b5ec11b72$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $688hO.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $2d927d5b5ec11b72$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $688hO.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $2d927d5b5ec11b72$var$buildFocusableOptions(props, selectValue) {
    return $2d927d5b5ec11b72$var$buildFocusableOptionsFromCategorizedOptions($2d927d5b5ec11b72$var$buildCategorizedOptions(props, selectValue));
}
function $2d927d5b5ec11b72$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$2d927d5b5ec11b72$var$shouldHideSelectedOptions(props) || !isSelected) && $2d927d5b5ec11b72$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $2d927d5b5ec11b72$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $2d927d5b5ec11b72$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $2d927d5b5ec11b72$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $2d927d5b5ec11b72$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $2d927d5b5ec11b72$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $2d927d5b5ec11b72$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $2d927d5b5ec11b72$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $2d927d5b5ec11b72$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $2d927d5b5ec11b72$var$getOptionValue(props, i) === candidate;
    });
}
function $2d927d5b5ec11b72$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $2d927d5b5ec11b72$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $2d927d5b5ec11b72$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $2d927d5b5ec11b72$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $iAnwu.default)(this, Select);
        _this = $2d927d5b5ec11b72$var$_callSuper(this, Select, [
            _props
        ]);
        (0, $5itxH.default)(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, $5itxH.default)(_this, "blockOptionHover", false);
        (0, $5itxH.default)(_this, "isComposing", false);
        // TODO
        (0, $5itxH.default)(_this, "initialTouchX", 0);
        (0, $5itxH.default)(_this, "initialTouchY", 0);
        (0, $5itxH.default)(_this, "openAfterFocus", false);
        (0, $5itxH.default)(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, $5itxH.default)(_this, "controlRef", null);
        (0, $5itxH.default)(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, $5itxH.default)(_this, "focusedOptionRef", null);
        (0, $5itxH.default)(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, $5itxH.default)(_this, "menuListRef", null);
        (0, $5itxH.default)(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, $5itxH.default)(_this, "inputRef", null);
        (0, $5itxH.default)(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, $5itxH.default)(_this, "focus", _this.focusInput);
        (0, $5itxH.default)(_this, "blur", _this.blurInput);
        (0, $5itxH.default)(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, $5itxH.default)(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue, shouldKeepInputOnSelect = _this$props2.shouldKeepInputOnSelect;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $jxLBU.fg)("platform_do_not_clear_input_for_multiselect")) _this.onInputChange(inputValue, {
                action: "set-value",
                prevInputValue: inputValue
            });
            else _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, $5itxH.default)(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $gRzS4.multiValueAsValue)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $gRzS4.multiValueAsValue)([].concat((0, $688hO.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $gRzS4.singleValueAsValue)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $gRzS4.singleValueAsValue)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, $5itxH.default)(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $gRzS4.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, $5itxH.default)(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $gRzS4.valueTernary)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        });
        (0, $5itxH.default)(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $gRzS4.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, $5itxH.default)(_this, "getFocusedOptionId", function(focusedOption) {
            return $2d927d5b5ec11b72$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, $5itxH.default)(_this, "getFocusableOptionsWithIds", function() {
            return $2d927d5b5ec11b72$var$buildFocusableOptionsWithIds($2d927d5b5ec11b72$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        });
        (0, $5itxH.default)(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, $5itxH.default)(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $gRzS4.classNames).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, $5itxH.default)(_this, "getOptionLabel", function(data) {
            return $2d927d5b5ec11b72$var$getOptionLabel(_this.props, data);
        });
        (0, $5itxH.default)(_this, "getOptionValue", function(data) {
            return $2d927d5b5ec11b72$var$getOptionValue(_this.props, data);
        });
        (0, $5itxH.default)(_this, "getStyles", function(key, props) {
            var base = (0, $8d2S5.defaultStyles)[key](props);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $gRzS4.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        });
        (0, $5itxH.default)(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, $5itxH.default)(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, $5itxH.default)(_this, "getComponents", function() {
            return (0, $9vbt6.defaultComponents)(_this.props);
        });
        (0, $5itxH.default)(_this, "buildCategorizedOptions", function() {
            return $2d927d5b5ec11b72$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, $5itxH.default)(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, $5itxH.default)(_this, "buildFocusableOptions", function() {
            return $2d927d5b5ec11b72$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, $5itxH.default)(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, $5itxH.default)(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $2d927d5b5ec11b72$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, $5itxH.default)(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, $5itxH.default)(_this, "onMenuMouseMove", function(event) {
            _this.blockOptionHover = false;
        });
        (0, $5itxH.default)(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest("[data-rbd-draggable-context-id]"))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        });
        (0, $5itxH.default)(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        });
        (0, $5itxH.default)(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, $5itxH.default)(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $gRzS4.isDocumentElement)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, $5itxH.default)(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, $5itxH.default)(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, $5itxH.default)(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, $5itxH.default)(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, $5itxH.default)(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, $5itxH.default)(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, $5itxH.default)(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, $5itxH.default)(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, $5itxH.default)(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, $5itxH.default)(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        });
        (0, $5itxH.default)(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            if ((0, $jxLBU.fg)("platform_dst_select_menu_close_on_blur")) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, $5itxH.default)(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, $5itxH.default)(_this, "shouldHideSelectedOptions", function() {
            return $2d927d5b5ec11b72$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, $5itxH.default)(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, $5itxH.default)(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, $5itxH.default)(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$2d927d5b5ec11b72$var$instanceId);
        _this.state.selectValue = (0, $gRzS4.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $2d927d5b5ec11b72$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $9cV9f.default)(Select, _Component);
    return (0, $9P5Ld.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gRzS4.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $gRzS4.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $aGSwI.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute("aria-label", inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props["aria-label"] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute("aria-label", normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute("aria-label");
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, $6cZa1.default)(obj) === "object" && obj !== null && "options" in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId("selected-value"), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $2d927d5b5ec11b72$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $2d927d5b5ec11b72$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $2d927d5b5ec11b72$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props["aria-describedby"] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? "" : this.getElementId("single-value") : this.getElementId("placeholder");
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    "aria-describedby": baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId("multi-message");
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    "aria-describedby": describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchstart", this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchmove", this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread({
                    "aria-autocomplete": "both",
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-expanded": menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    "aria-haspopup": this.props["UNSAFE_is_experimental_generic"] ? "dialog" : "listbox",
                    "aria-invalid": this.props["aria-invalid"] || isInvalid,
                    "aria-label": this.props["aria-label"] || label,
                    "aria-labelledby": this.props["aria-labelledby"] || labelId,
                    "aria-required": required || isRequired,
                    role: "combobox",
                    "aria-activedescendant": this.props["UNSAFE_is_experimental_generic"] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7WwtK.default), (0, $9RXLj.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $gRzS4.noop),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Input, (0, $9RXLj.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Placeholder, (0, $9RXLj.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $2d927d5b5ec11b72$var$_objectSpread({
                        id: this.getElementId("placeholder")
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(MultiValue, (0, $9RXLj.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            "data-testid": "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId("selected-value"), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread({}, testId && {
                            "data-testid": "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId("selected-value"), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(SingleValue, (0, $9RXLj.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId("single-value")
                    }
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $2d927d5b5ec11b72$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    "data-testid": "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === "compact";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ClearIndicator, (0, $9RXLj.default)({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === "compact";
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(LoadingIndicator, (0, $9RXLj.default)({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === "compact";
                var innerProps = $2d927d5b5ec11b72$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                }, testId && {
                    "data-testid": "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(DropdownIndicator, (0, $9RXLj.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId("option"), "-").concat(id);
                    var innerProps = $2d927d5b5ec11b72$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props["UNSAFE_is_experimental_generic"] ? "listitem" : "option",
                        "aria-selected": _this6.props["UNSAFE_is_experimental_generic"] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        "aria-disabled": !isDisabled ? undefined : isDisabled,
                        "aria-describedby": headingId
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Option, (0, $9RXLj.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === "group") {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId("group"), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Group, (0, $9RXLj.default)({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $2d927d5b5ec11b72$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    "data-testid": "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === "option") return render(item, "".concat(item.index));
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(NoOptionsMessage, (0, $9RXLj.default)({}, commonProps, {
                        innerProps: $2d927d5b5ec11b72$var$_objectSpread({}, testId && {
                            "data-testid": "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $fjGa0.MenuPlacer), (0, $9RXLj.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Menu, (0, $9RXLj.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $2d927d5b5ec11b72$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId("listbox") : undefined
                        }, testId && {
                            "data-testid": "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5QjDl.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(MenuList, (0, $9RXLj.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread({
                                role: _this6.props["UNSAFE_is_experimental_generic"] ? "dialog" : "listbox"
                            }, _this6.props["UNSAFE_is_experimental_generic"] && {
                                "aria-labelledby": ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId("input")
                            }), {}, {
                                "aria-multiselectable": !commonProps.isMulti || _this6.props["UNSAFE_is_experimental_generic"] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId("listbox")
                            }, testId && {
                                "data-testid": "".concat(testId, "-select--listbox")
                            }), (0, $aGSwI.isSafari)() && !_this6.props["UNSAFE_is_experimental_generic"] && {
                                "aria-describedby": ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId("input")
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props["UNSAFE_is_experimental_generic"] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(MenuPortal, (0, $9RXLj.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e289l.default), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hx8bc.default), (0, $9RXLj.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? "Use left or right arrow keys to navigate selected items" : "");
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
                    id: this.getElementId("multi-message"),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? "default" : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? "default" : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === "compact";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(SelectContainer, (0, $9RXLj.default)({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $2d927d5b5ec11b72$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        "data-testid": testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Control, (0, $9RXLj.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $2d927d5b5ec11b72$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        "data-testid": "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ValueContainer, (0, $9RXLj.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread({}, testId && {
                        "data-testid": "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $aGSwI.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: "application"
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(IndicatorsContainer, (0, $9RXLj.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $2d927d5b5ec11b72$var$_objectSpread({}, testId && {
                        "data-testid": "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3v0EL.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $gRzS4.cleanValue)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $2d927d5b5ec11b72$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $2d927d5b5ec11b72$var$buildFocusableOptionsWithIds($2d927d5b5ec11b72$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $2d927d5b5ec11b72$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $2d927d5b5ec11b72$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $2d927d5b5ec11b72$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $gRzS4.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return $2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread($2d927d5b5ec11b72$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $iSvIT.Component));
(0, $5itxH.default)($2d927d5b5ec11b72$export$2e2bcd8739ae039, "defaultProps", $2d927d5b5ec11b72$export$9c21a3269931e1e6);

});
parcelRegister("gdbXW", function(module, exports) {
function $bcd72466654dbbf4$export$2e2bcd8739ae039(r) {
    throw new TypeError('"' + r + '" is read-only');
}

});

parcelRegister("6cZa1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48534e5188c1eb06$export$2e2bcd8739ae039; });
function $48534e5188c1eb06$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $48534e5188c1eb06$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $48534e5188c1eb06$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iAnwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d87dd5f9c3f0a640$export$2e2bcd8739ae039; });
function $d87dd5f9c3f0a640$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9P5Ld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726d586a13f6d5f0$export$2e2bcd8739ae039; });

var $bDpiC = parcelRequire("bDpiC");
function $726d586a13f6d5f0$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $bDpiC.default)(o.key), o);
    }
}
function $726d586a13f6d5f0$export$2e2bcd8739ae039(e, r, t) {
    return r && $726d586a13f6d5f0$var$_defineProperties(e.prototype, r), t && $726d586a13f6d5f0$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("bDpiC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8786f62a7a78b29a$export$2e2bcd8739ae039; });

var $6cZa1 = parcelRequire("6cZa1");

var $6E68g = parcelRequire("6E68g");
function $8786f62a7a78b29a$export$2e2bcd8739ae039(t) {
    var i = (0, $6E68g.default)(t, "string");
    return "symbol" == (0, $6cZa1.default)(i) ? i : i + "";
}

});
parcelRegister("6E68g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d6b3c4087443e76$export$2e2bcd8739ae039; });

var $6cZa1 = parcelRequire("6cZa1");
function $4d6b3c4087443e76$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6cZa1.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6cZa1.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("68nHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4775e00742face05$export$2e2bcd8739ae039; });

var $6cZa1 = parcelRequire("6cZa1");

var $fPnJm = parcelRequire("fPnJm");
function $4775e00742face05$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6cZa1.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $fPnJm.default)(t);
}

});
parcelRegister("fPnJm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b85e06d4b774b5ab$export$2e2bcd8739ae039; });
function $b85e06d4b774b5ab$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("eWqoV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02cea0df8932a57b$export$2e2bcd8739ae039; });
function $02cea0df8932a57b$export$2e2bcd8739ae039(t) {
    return $02cea0df8932a57b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $02cea0df8932a57b$export$2e2bcd8739ae039(t);
}

});

parcelRegister("9cV9f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b41907b212327d4$export$2e2bcd8739ae039; });

var $fu5ZX = parcelRequire("fu5ZX");
function $6b41907b212327d4$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $fu5ZX.default)(t, e);
}

});
parcelRegister("fu5ZX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b45e4f819d79d710$export$2e2bcd8739ae039; });
function $b45e4f819d79d710$export$2e2bcd8739ae039(t, e) {
    return $b45e4f819d79d710$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b45e4f819d79d710$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("5itxH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3db58cb834efb79b$export$2e2bcd8739ae039; });

var $bDpiC = parcelRequire("bDpiC");
function $3db58cb834efb79b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bDpiC.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("688hO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4769eaef7ab2f761$export$2e2bcd8739ae039; });

var $aSHOF = parcelRequire("aSHOF");

var $hyuPt = parcelRequire("hyuPt");

var $93CGf = parcelRequire("93CGf");

var $1bhNq = parcelRequire("1bhNq");
function $4769eaef7ab2f761$export$2e2bcd8739ae039(r) {
    return (0, $aSHOF.default)(r) || (0, $hyuPt.default)(r) || (0, $93CGf.default)(r) || (0, $1bhNq.default)();
}

});
parcelRegister("aSHOF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec0ef83415b5f47$export$2e2bcd8739ae039; });

var $8M7z0 = parcelRequire("8M7z0");
function $7ec0ef83415b5f47$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $8M7z0.default)(r);
}

});
parcelRegister("8M7z0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6638ac61ecf8b0ca$export$2e2bcd8739ae039; });
function $6638ac61ecf8b0ca$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("hyuPt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc7d86ab1da44ff4$export$2e2bcd8739ae039; });
function $cc7d86ab1da44ff4$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("93CGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $698265fc1203be45$export$2e2bcd8739ae039; });

var $8M7z0 = parcelRequire("8M7z0");
function $698265fc1203be45$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $8M7z0.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $8M7z0.default)(r, a) : void 0;
    }
}

});

parcelRegister("1bhNq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dc49f76ed3b30a5$export$2e2bcd8739ae039; });
function $0dc49f76ed3b30a5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("aGSwI", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $7c881f7c7b3e20c0$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isAppleDevice", function () { return $7c881f7c7b3e20c0$export$e1865c3bedcd822b; });
function $7c881f7c7b3e20c0$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_userAgentData = window.navigator["userAgentData"]) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $7c881f7c7b3e20c0$var$isIPhone() {
    return $7c881f7c7b3e20c0$var$testPlatform(/^iPhone/i);
}
function $7c881f7c7b3e20c0$var$isMac() {
    return $7c881f7c7b3e20c0$var$testPlatform(/^Mac/i);
}
function $7c881f7c7b3e20c0$var$isIPad() {
    return $7c881f7c7b3e20c0$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $7c881f7c7b3e20c0$var$isMac() && navigator.maxTouchPoints > 1;
}
function $7c881f7c7b3e20c0$var$isIOS() {
    return $7c881f7c7b3e20c0$var$isIPhone() || $7c881f7c7b3e20c0$var$isIPad();
}
function $7c881f7c7b3e20c0$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $7c881f7c7b3e20c0$export$e1865c3bedcd822b() {
    return $7c881f7c7b3e20c0$var$isMac() || $7c881f7c7b3e20c0$var$isIOS();
}

});

parcelRegister("3NC2H", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", function () { return $2c43752e89f80fd7$export$f4da216a6ca54656; });
$parcel$export(module.exports, "getOptionLabel", function () { return $2c43752e89f80fd7$export$dac6ace3020563ca; });
$parcel$export(module.exports, "getOptionValue", function () { return $2c43752e89f80fd7$export$40be908210c5a79c; });
$parcel$export(module.exports, "isOptionDisabled", function () { return $2c43752e89f80fd7$export$56bd0c8d90db075; });
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $2c43752e89f80fd7$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $2c43752e89f80fd7$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $2c43752e89f80fd7$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $2c43752e89f80fd7$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};

});

parcelRegister("9vbt6", function(module, exports) {

$parcel$export(module.exports, "components", function () { return $6eafe7b19c839e58$export$9b5ac10f59f76296; });
$parcel$export(module.exports, "defaultComponents", function () { return $6eafe7b19c839e58$export$71abc632aa29e6fe; });

var $5itxH = parcelRequire("5itxH");

var $hmorv = parcelRequire("hmorv");

var $beUig = parcelRequire("beUig");

var $4xLgD = parcelRequire("4xLgD");

var $dnkuV = parcelRequire("dnkuV");

var $frrXG = parcelRequire("frrXG");

var $fjGa0 = parcelRequire("fjGa0");

var $lcn7s = parcelRequire("lcn7s");

var $59Lal = parcelRequire("59Lal");

var $eQIBp = parcelRequire("eQIBp");

var $kFLGs = parcelRequire("kFLGs");
function $6eafe7b19c839e58$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6eafe7b19c839e58$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6eafe7b19c839e58$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6eafe7b19c839e58$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6eafe7b19c839e58$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $dnkuV.ClearIndicator),
    Control: (0, $beUig.default),
    DropdownIndicator: (0, $dnkuV.DropdownIndicator),
    Group: (0, $4xLgD.default),
    GroupHeading: (0, $4xLgD.GroupHeading),
    IndicatorsContainer: (0, $hmorv.IndicatorsContainer),
    Input: (0, $frrXG.default),
    LoadingIndicator: (0, $dnkuV.LoadingIndicator),
    Menu: (0, $fjGa0.default),
    MenuList: (0, $fjGa0.MenuList),
    MenuPortal: (0, $fjGa0.MenuPortal),
    LoadingMessage: (0, $fjGa0.LoadingMessage),
    NoOptionsMessage: (0, $fjGa0.NoOptionsMessage),
    MultiValue: (0, $lcn7s.default),
    MultiValueContainer: (0, $lcn7s.MultiValueContainer),
    MultiValueLabel: (0, $lcn7s.MultiValueLabel),
    MultiValueRemove: (0, $lcn7s.MultiValueRemove),
    Option: (0, $59Lal.default),
    Placeholder: (0, $eQIBp.default),
    SelectContainer: (0, $hmorv.SelectContainer),
    SingleValue: (0, $kFLGs.default),
    ValueContainer: (0, $hmorv.ValueContainer)
};
var $6eafe7b19c839e58$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $6eafe7b19c839e58$var$_objectSpread($6eafe7b19c839e58$var$_objectSpread({}, $6eafe7b19c839e58$export$9b5ac10f59f76296), props.components);
};

});
parcelRegister("hmorv", function(module, exports) {

$parcel$export(module.exports, "containerCSS", function () { return $ca37738fbb4f3320$export$949392aeaf7d2e3a; });
$parcel$export(module.exports, "SelectContainer", function () { return $ca37738fbb4f3320$export$446eebadefe1123b; });
$parcel$export(module.exports, "valueContainerCSS", function () { return $ca37738fbb4f3320$export$47aec73c7aa6b9aa; });
$parcel$export(module.exports, "ValueContainer", function () { return $ca37738fbb4f3320$export$4dc9f58ad9a1a000; });
$parcel$export(module.exports, "indicatorsContainerCSS", function () { return $ca37738fbb4f3320$export$9d74e3c8b5868ad7; });
$parcel$export(module.exports, "IndicatorsContainer", function () { return $ca37738fbb4f3320$export$d0ffd7e649cab6f; });
/* containers.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $jxLBU = parcelRequire("jxLBU");

var $gRzS4 = parcelRequire("gRzS4");
var $ca37738fbb4f3320$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $ca37738fbb4f3320$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
var $ca37738fbb4f3320$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $ca37738fbb4f3320$var$containerStyles.default,
            isRtl && $ca37738fbb4f3320$var$containerStyles.rtl,
            isDisabled && $ca37738fbb4f3320$var$containerStyles.disabled,
            (0, $jxLBU.fg)("platform_design_system_team_safari_input_fix") && $ca37738fbb4f3320$var$containerStyles.ff_safari_input_fix,
            (0, $byv0L.cx)(className, xcss, "-container")
        ]),
        style: css
    }, innerProps), children);
};
var $ca37738fbb4f3320$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $ca37738fbb4f3320$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $ca37738fbb4f3320$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $gRzS4.getStyleProps)(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $ca37738fbb4f3320$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $ca37738fbb4f3320$var$valueContainerStyles.flex,
            isCompact && $ca37738fbb4f3320$var$valueContainerStyles.compact,
            (0, $byv0L.cx)(className, xcss, "-ValueContainer")
        ]),
        style: css
    }, innerProps), children);
};
var $ca37738fbb4f3320$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $ca37738fbb4f3320$var$indicatorContainerStyles = null;
var $ca37738fbb4f3320$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $gRzS4.getStyleProps)(props, "indicatorsContainer", {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $byv0L.cx)(className, xcss, "-IndicatorsContainer")
        ])
    }, innerProps), children);
};

});
parcelRegister("cwf3q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91d426a597cdd1fd$export$2e2bcd8739ae039; });
const $91d426a597cdd1fd$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $91d426a597cdd1fd$var$ATOMIC_GROUP_LENGTH = 5;
function $91d426a597cdd1fd$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $91d426a597cdd1fd$var$UNDERSCORE_UNICODE ? $91d426a597cdd1fd$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("byv0L", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $869aece9977b5de7$export$a274e22fb40f762e; });

var $cwf3q = parcelRequire("cwf3q");
const $869aece9977b5de7$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $cwf3q.default)(actualStyles);
};

});

parcelRegister("gRzS4", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $c46d6bd10dbb03d7$export$8793edee2d425525; });
$parcel$export(module.exports, "classNames", function () { return $c46d6bd10dbb03d7$export$ce4ab0c55987d1ff; });
$parcel$export(module.exports, "cleanValue", function () { return $c46d6bd10dbb03d7$export$33f062f47f21a01; });
$parcel$export(module.exports, "cleanCommonProps", function () { return $c46d6bd10dbb03d7$export$8e9fd4287627890c; });
$parcel$export(module.exports, "getStyleProps", function () { return $c46d6bd10dbb03d7$export$26417cabd806a658; });
$parcel$export(module.exports, "handleInputChange", function () { return $c46d6bd10dbb03d7$export$2096bae78ecda911; });
$parcel$export(module.exports, "isDocumentElement", function () { return $c46d6bd10dbb03d7$export$d8a62a489b442872; });
$parcel$export(module.exports, "normalizedHeight", function () { return $c46d6bd10dbb03d7$export$2e0654fad740d2e4; });
$parcel$export(module.exports, "getScrollTop", function () { return $c46d6bd10dbb03d7$export$c4a223a8ba9e4ea5; });
$parcel$export(module.exports, "scrollTo", function () { return $c46d6bd10dbb03d7$export$3f99968195accfaf; });
$parcel$export(module.exports, "getScrollParent", function () { return $c46d6bd10dbb03d7$export$cfa2225e87938781; });
$parcel$export(module.exports, "animatedScrollTo", function () { return $c46d6bd10dbb03d7$export$858c30343199f3af; });
$parcel$export(module.exports, "scrollIntoView", function () { return $c46d6bd10dbb03d7$export$53a0910f038337bd; });
$parcel$export(module.exports, "getBoundingClientObj", function () { return $c46d6bd10dbb03d7$export$7807c2a424c2f6d1; });
$parcel$export(module.exports, "isTouchCapable", function () { return $c46d6bd10dbb03d7$export$56963d77dbffdde7; });
$parcel$export(module.exports, "isMobileDevice", function () { return $c46d6bd10dbb03d7$export$44f917bf91becd01; });
$parcel$export(module.exports, "supportsPassiveEvents", function () { return $c46d6bd10dbb03d7$export$b0622a6911dbeaf5; });
$parcel$export(module.exports, "notNullish", function () { return $c46d6bd10dbb03d7$export$aedb69ff3e31596c; });
$parcel$export(module.exports, "valueTernary", function () { return $c46d6bd10dbb03d7$export$40fb9515c784cc3b; });
$parcel$export(module.exports, "singleValueAsValue", function () { return $c46d6bd10dbb03d7$export$dea4763e29237f4c; });
$parcel$export(module.exports, "multiValueAsValue", function () { return $c46d6bd10dbb03d7$export$d1ca752ec761b95b; });
$parcel$export(module.exports, "removeProps", function () { return $c46d6bd10dbb03d7$export$4213b25a1c4e877; });
$parcel$export(module.exports, "filterUnsupportedSelectors", function () { return $c46d6bd10dbb03d7$export$bf2eda47afa5f369; });

var $Y7EFl = parcelRequire("Y7EFl");

var $5itxH = parcelRequire("5itxH");

var $85v1J = parcelRequire("85v1J");

var $6cZa1 = parcelRequire("6cZa1");
var $c46d6bd10dbb03d7$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $c46d6bd10dbb03d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c46d6bd10dbb03d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c46d6bd10dbb03d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c46d6bd10dbb03d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c46d6bd10dbb03d7$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $c46d6bd10dbb03d7$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $c46d6bd10dbb03d7$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($c46d6bd10dbb03d7$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
var $c46d6bd10dbb03d7$export$33f062f47f21a01 = function cleanValue(value) {
    if ($c46d6bd10dbb03d7$var$isArray(value)) return value.filter(Boolean);
    if ((0, $6cZa1.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
var $c46d6bd10dbb03d7$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, $85v1J.default)(props, $c46d6bd10dbb03d7$var$_excluded);
    return $c46d6bd10dbb03d7$var$_objectSpread({}, innerProps);
};
var $c46d6bd10dbb03d7$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $c46d6bd10dbb03d7$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === "string") return newValue;
    }
    return inputValue;
}
function $c46d6bd10dbb03d7$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $c46d6bd10dbb03d7$export$2e0654fad740d2e4(el) {
    if ($c46d6bd10dbb03d7$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $c46d6bd10dbb03d7$export$c4a223a8ba9e4ea5(el) {
    if ($c46d6bd10dbb03d7$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $c46d6bd10dbb03d7$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($c46d6bd10dbb03d7$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $c46d6bd10dbb03d7$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $c46d6bd10dbb03d7$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $c46d6bd10dbb03d7$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c46d6bd10dbb03d7$export$8793edee2d425525;
    var start = $c46d6bd10dbb03d7$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $c46d6bd10dbb03d7$var$easeOutCubic(currentTime, start, change, duration);
        $c46d6bd10dbb03d7$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $c46d6bd10dbb03d7$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $c46d6bd10dbb03d7$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $c46d6bd10dbb03d7$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $c46d6bd10dbb03d7$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $c46d6bd10dbb03d7$export$56963d77dbffdde7() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
function $c46d6bd10dbb03d7$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $c46d6bd10dbb03d7$var$passiveOptionAccessed = false;
var $c46d6bd10dbb03d7$var$options = {
    get passive () {
        return $c46d6bd10dbb03d7$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $c46d6bd10dbb03d7$var$w = typeof window !== "undefined" ? window : {};
if ($c46d6bd10dbb03d7$var$w.addEventListener && $c46d6bd10dbb03d7$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $c46d6bd10dbb03d7$var$w.addEventListener("p", $c46d6bd10dbb03d7$export$8793edee2d425525, $c46d6bd10dbb03d7$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $c46d6bd10dbb03d7$var$w.removeEventListener("p", $c46d6bd10dbb03d7$export$8793edee2d425525, false);
}
var $c46d6bd10dbb03d7$export$b0622a6911dbeaf5 = $c46d6bd10dbb03d7$var$passiveOptionAccessed;
function $c46d6bd10dbb03d7$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $c46d6bd10dbb03d7$var$isArray(arg) {
    return Array.isArray(arg);
}
function $c46d6bd10dbb03d7$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $c46d6bd10dbb03d7$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $c46d6bd10dbb03d7$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $c46d6bd10dbb03d7$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $Y7EFl.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $Y7EFl.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $c46d6bd10dbb03d7$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ":",
        // pseudo-classes/elements
        "[",
        // attribute selectors
        ">",
        // child combinator
        "+",
        // adjacent sibling combinator
        "~",
        // general sibling combinator
        " ",
        // descendant combinator
        "*",
        // universal selector
        "#",
        // ID selector
        ".",
        // class selector
        "@",
        // at-rules
        "&",
        // parent selector
        "|",
        // namespace separator
        "^",
        // starts with
        "$",
        // ends with
        "=" // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});
parcelRegister("Y7EFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b4b8ad09cdcd782$export$2e2bcd8739ae039; });

var $d8NSP = parcelRequire("d8NSP");

var $7F0EK = parcelRequire("7F0EK");

var $93CGf = parcelRequire("93CGf");

var $eI0hZ = parcelRequire("eI0hZ");
function $0b4b8ad09cdcd782$export$2e2bcd8739ae039(r, e) {
    return (0, $d8NSP.default)(r) || (0, $7F0EK.default)(r, e) || (0, $93CGf.default)(r, e) || (0, $eI0hZ.default)();
}

});
parcelRegister("d8NSP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9912b785723f12b7$export$2e2bcd8739ae039; });
function $9912b785723f12b7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("7F0EK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $593cdf0c1369e86a$export$2e2bcd8739ae039; });
function $593cdf0c1369e86a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("eI0hZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab55662c002896ea$export$2e2bcd8739ae039; });
function $ab55662c002896ea$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("85v1J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e36dbaa051a53f7$export$2e2bcd8739ae039; });

var $9H3v8 = parcelRequire("9H3v8");
function $5e36dbaa051a53f7$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $9H3v8.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("9H3v8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70ead87351c3e688$export$2e2bcd8739ae039; });
function $70ead87351c3e688$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("beUig", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $82ecab3d94f18f93$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $82ecab3d94f18f93$export$2e2bcd8739ae039; });
/* control.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $gRzS4 = parcelRequire("gRzS4");
var $82ecab3d94f18f93$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123byq51 _d0altlke _irr31d5g _1ogl1caj",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $82ecab3d94f18f93$export$dbf350e5966cf602 = function css() {
    return {};
};
var $82ecab3d94f18f93$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        ref: innerRef,
        className: (0, $cwf3q.default)([
            $82ecab3d94f18f93$var$styles.default,
            isDisabled && $82ecab3d94f18f93$var$styles.disabled,
            isInvalid && $82ecab3d94f18f93$var$styles.invalid,
            isCompact && $82ecab3d94f18f93$var$styles.compact,
            appearance === "subtle" && $82ecab3d94f18f93$var$styles.subtle,
            appearance === "subtle" && isFocused && $82ecab3d94f18f93$var$styles.subtleFocused,
            isFocused && $82ecab3d94f18f93$var$styles.focused,
            appearance === "none" && $82ecab3d94f18f93$var$styles.none,
            (0, $byv0L.cx)(className, xcss, "-control")
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$82ecab3d94f18f93$export$2e2bcd8739ae039 = $82ecab3d94f18f93$var$Control;

});

parcelRegister("4xLgD", function(module, exports) {

$parcel$export(module.exports, "groupCSS", function () { return $34eee8cf65c84d52$export$b6794329c1460634; });
$parcel$export(module.exports, "groupHeadingCSS", function () { return $34eee8cf65c84d52$export$e5a7fbb542efcb7d; });
$parcel$export(module.exports, "GroupHeading", function () { return $34eee8cf65c84d52$export$85c8b41a3cd87edc; });
$parcel$export(module.exports, "default", function () { return $34eee8cf65c84d52$export$2e2bcd8739ae039; });
/* group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $85v1J = parcelRequire("85v1J");

var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $gRzS4 = parcelRequire("gRzS4");
var $34eee8cf65c84d52$var$_excluded = [
    "data"
];
var $34eee8cf65c84d52$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $34eee8cf65c84d52$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $34eee8cf65c84d52$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "group", {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $34eee8cf65c84d52$var$styles.root,
            (0, $byv0L.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, "-Group")
        ])
    }), label && /*#__PURE__*/ $iSvIT.createElement(Heading, (0, $9RXLj.default)({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $iSvIT.createElement("div", null, children));
};
var $34eee8cf65c84d52$var$headingStyles = null;
var $34eee8cf65c84d52$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $34eee8cf65c84d52$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $gRzS4.cleanCommonProps)(props), data = _cleanCommonProps.data, innerProps = (0, $85v1J.default)(_cleanCommonProps, $34eee8cf65c84d52$var$_excluded);
    var _getStyleProps2 = (0, $gRzS4.getStyleProps)(props, "groupHeading", {
        "group-heading": true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $byv0L.cx)(className, xcss, "-group")
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$34eee8cf65c84d52$export$2e2bcd8739ae039 = $34eee8cf65c84d52$var$Group;

});

parcelRegister("dnkuV", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", function () { return $9bcd52c1aea3aab9$export$e1687335805e1230; });
$parcel$export(module.exports, "DropdownIndicator", function () { return $9bcd52c1aea3aab9$export$ec98719d3db7f2e4; });
$parcel$export(module.exports, "clearIndicatorCSS", function () { return $9bcd52c1aea3aab9$export$9c0419fd944c1def; });
$parcel$export(module.exports, "ClearIndicator", function () { return $9bcd52c1aea3aab9$export$ecf9cf59142dd54a; });
$parcel$export(module.exports, "loadingIndicatorCSS", function () { return $9bcd52c1aea3aab9$export$1d3f24cde248e6b5; });
$parcel$export(module.exports, "LoadingIndicator", function () { return $9bcd52c1aea3aab9$export$7c20be4c1d342248; });
/* indicators.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5itxH = parcelRequire("5itxH");

var $85v1J = parcelRequire("85v1J");

var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $2TXGH = parcelRequire("2TXGH");

var $Z8bUF = parcelRequire("Z8bUF");

var $gABtt = parcelRequire("gABtt");
var $2KsZn = parcelRequire("2KsZn");

var $ABMe6 = parcelRequire("ABMe6");

var $gRzS4 = parcelRequire("gRzS4");
var $9bcd52c1aea3aab9$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $9bcd52c1aea3aab9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bcd52c1aea3aab9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bcd52c1aea3aab9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bcd52c1aea3aab9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $9bcd52c1aea3aab9$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
var $9bcd52c1aea3aab9$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $9bcd52c1aea3aab9$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
var $9bcd52c1aea3aab9$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $9bcd52c1aea3aab9$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $9bcd52c1aea3aab9$var$dropdownStyles.default,
            isDisabled && $9bcd52c1aea3aab9$var$dropdownStyles.disabled,
            isCompact && $9bcd52c1aea3aab9$var$dropdownStyles.compact,
            (0, $byv0L.cx)(className, xcss, "-indicatorContainer")
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $iSvIT.createElement((0, $gABtt.default), {
        as: "span",
        xcss: $9bcd52c1aea3aab9$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2TXGH))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
        size: "small"
    })));
};
var $9bcd52c1aea3aab9$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $9bcd52c1aea3aab9$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
var $9bcd52c1aea3aab9$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? "clear" : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $gRzS4.getStyleProps)(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $9bcd52c1aea3aab9$var$clearIndicatorStyles.default,
            isCompact && $9bcd52c1aea3aab9$var$clearIndicatorStyles.compact,
            (0, $byv0L.cx)(className, xcss, "-indicatorContainer")
        ])
    }, innerProps), /*#__PURE__*/ $iSvIT.createElement((0, $2KsZn.default), {
        xcss: $9bcd52c1aea3aab9$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($Z8bUF))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
        size: "small"
    })));
};
var $9bcd52c1aea3aab9$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $9bcd52c1aea3aab9$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
var $9bcd52c1aea3aab9$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, $85v1J.default)(_ref, $9bcd52c1aea3aab9$var$_excluded);
    var _getStyleProps3 = (0, $gRzS4.getStyleProps)($9bcd52c1aea3aab9$var$_objectSpread($9bcd52c1aea3aab9$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $9bcd52c1aea3aab9$var$loadingIndicatorStyles.default,
            isCompact && $9bcd52c1aea3aab9$var$loadingIndicatorStyles.compact,
            (0, $byv0L.cx)(className, xcss, "-loadingIndicator")
        ])
    }, innerProps), /*#__PURE__*/ $iSvIT.createElement((0, $ABMe6.default), {
        size: "small"
    }));
};

});
parcelRegister("2TXGH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21cf04943510106a$var$_react = $21cf04943510106a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $21cf04943510106a$var$_chevronDown = $21cf04943510106a$var$_interopRequireDefault((parcelRequire("41KH0")));

var $21cf04943510106a$var$_chevronDown2 = $21cf04943510106a$var$_interopRequireDefault((parcelRequire("bR9cs")));
function $21cf04943510106a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21cf04943510106a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $21cf04943510106a$var$_react.default.createElement($21cf04943510106a$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $21cf04943510106a$var$_chevronDown2.default
    }, props));
$21cf04943510106a$var$ChevronDownIcon.displayName = "ChevronDownIconMigration";
var $21cf04943510106a$var$_default = module.exports.default = $21cf04943510106a$var$ChevronDownIcon;

});
parcelRegister("41KH0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2eeb799e0ddd6da4$var$_react = $2eeb799e0ddd6da4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2eeb799e0ddd6da4$var$_baseNew = $2eeb799e0ddd6da4$var$_interopRequireDefault((parcelRequire("h1I1H")));
function $2eeb799e0ddd6da4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2eeb799e0ddd6da4$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $2eeb799e0ddd6da4$var$_react.default.createElement($2eeb799e0ddd6da4$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$2eeb799e0ddd6da4$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $2eeb799e0ddd6da4$var$_default = module.exports.default = $2eeb799e0ddd6da4$var$ChevronDownIcon;

});
parcelRegister("h1I1H", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7aziq")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("7aziq")).Icon; });

var $7aziq = parcelRequire("7aziq");

});
parcelRegister("7aziq", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $5384d8a3846f33ce$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $5384d8a3846f33ce$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $5384d8a3846f33ce$var$svgStyles = null;
var $5384d8a3846f33ce$var$iconStyles = null;
var $5384d8a3846f33ce$var$utilityIconStyles = null;
var $5384d8a3846f33ce$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $5384d8a3846f33ce$var$baseHcmStyles = null;
var $5384d8a3846f33ce$var$scaleSize = null;
var $5384d8a3846f33ce$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5384d8a3846f33ce$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5384d8a3846f33ce$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5384d8a3846f33ce$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $5384d8a3846f33ce$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $5384d8a3846f33ce$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $5384d8a3846f33ce$var$baseSizeMap[type];
    var viewBoxPadding = $5384d8a3846f33ce$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $cwf3q.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $cwf3q.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $5384d8a3846f33ce$var$utilSizes[spacing] : size === "small" ? $5384d8a3846f33ce$var$coreSizeSmall[spacing] : $5384d8a3846f33ce$var$coreSizeMedium[spacing]
        ])
    }));
});
var $5384d8a3846f33ce$export$2e2bcd8739ae039 = $5384d8a3846f33ce$export$f04a61298a47a40f;

});



parcelRegister("bR9cs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a1bc7d90b43297c$var$_react = $8a1bc7d90b43297c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $kmon1 = parcelRequire("kmon1");
function $8a1bc7d90b43297c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a1bc7d90b43297c$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $8a1bc7d90b43297c$var$_react.default.createElement($kmon1.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$8a1bc7d90b43297c$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $8a1bc7d90b43297c$var$_default = module.exports.default = $8a1bc7d90b43297c$var$ChevronDownIcon;

});
parcelRegister("kmon1", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ed28c423e3894a50$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $5itxH = parcelRequire("5itxH");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");
function $ed28c423e3894a50$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed28c423e3894a50$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed28c423e3894a50$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed28c423e3894a50$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ed28c423e3894a50$var$iconStyles = null;
var $ed28c423e3894a50$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $ed28c423e3894a50$var$baseHcmStyles = null;
var $ed28c423e3894a50$var$primaryEqualsSecondaryHcmStyles = null;
var $ed28c423e3894a50$var$secondaryTransparentHcmStyles = null;
var $ed28c423e3894a50$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $iSvIT.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $9RXLj.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $ed28c423e3894a50$var$_objectSpread($ed28c423e3894a50$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $cwf3q.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $ed28c423e3894a50$var$sizeStyles[size]
        ])
    }));
});
var $ed28c423e3894a50$export$2e2bcd8739ae039 = $ed28c423e3894a50$export$f04a61298a47a40f;

});



parcelRegister("Z8bUF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c64b1bb7f30549dd379d26abd8d4a76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b7c0d35e24ac737$var$_react = $0b7c0d35e24ac737$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0b7c0d35e24ac737$var$_crossCircle = $0b7c0d35e24ac737$var$_interopRequireDefault((parcelRequire("h8K1g")));

var $0b7c0d35e24ac737$var$_selectClear = $0b7c0d35e24ac737$var$_interopRequireDefault((parcelRequire("eN5I7")));
function $0b7c0d35e24ac737$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b7c0d35e24ac737$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $0b7c0d35e24ac737$var$_react.default.createElement($0b7c0d35e24ac737$var$_crossCircle.default, Object.assign({
        name: "CrossCircleIcon",
        LEGACY_fallbackIcon: $0b7c0d35e24ac737$var$_selectClear.default
    }, props));
$0b7c0d35e24ac737$var$CrossCircleIcon.displayName = "CrossCircleIconMigration";
var $0b7c0d35e24ac737$var$_default = module.exports.default = $0b7c0d35e24ac737$var$CrossCircleIcon;

});
parcelRegister("h8K1g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7a6e18061d9155a$var$_react = $c7a6e18061d9155a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c7a6e18061d9155a$var$_baseNew = $c7a6e18061d9155a$var$_interopRequireDefault((parcelRequire("h1I1H")));
function $c7a6e18061d9155a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7a6e18061d9155a$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $c7a6e18061d9155a$var$_react.default.createElement($c7a6e18061d9155a$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$c7a6e18061d9155a$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $c7a6e18061d9155a$var$_default = module.exports.default = $c7a6e18061d9155a$var$CrossCircleIcon;

});

parcelRegister("eN5I7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac4a124d1d6d7323$var$_react = $ac4a124d1d6d7323$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $kmon1 = parcelRequire("kmon1");
function $ac4a124d1d6d7323$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ac4a124d1d6d7323$var$SelectClearIcon = (props)=>/*#__PURE__*/ $ac4a124d1d6d7323$var$_react.default.createElement($kmon1.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props));
$ac4a124d1d6d7323$var$SelectClearIcon.displayName = "SelectClearIcon";
var $ac4a124d1d6d7323$var$_default = module.exports.default = $ac4a124d1d6d7323$var$SelectClearIcon;

});


parcelRegister("gABtt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c13d13c7640184f6$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $Afb1u = parcelRequire("Afb1u");

var $hWWFS = parcelRequire("hWWFS");
var $c13d13c7640184f6$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $c13d13c7640184f6$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $c13d13c7640184f6$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $cwf3q.default)([
            $c13d13c7640184f6$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c13d13c7640184f6$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $85v1J.default)(_ref2, $c13d13c7640184f6$var$_excluded);
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $iSvIT.createElement($c13d13c7640184f6$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $iSvIT.createElement((0, $hWWFS.default), (0, $9RXLj.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $Afb1u.cx)(grow === "hug" && $c13d13c7640184f6$var$styles.hug, grow === "fill" && $c13d13c7640184f6$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$c13d13c7640184f6$var$Inline.displayName = "Inline";
var $c13d13c7640184f6$export$2e2bcd8739ae039 = $c13d13c7640184f6$var$Inline;

});
parcelRegister("Afb1u", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $06cf22b3b85c2a00$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $1Slnq = parcelRequire("1Slnq");
var $06cf22b3b85c2a00$var$_createStrictAPI = (0, $1Slnq.createStrictAPI)(), $06cf22b3b85c2a00$var$XCSSProp = $06cf22b3b85c2a00$var$_createStrictAPI.XCSSProp, $06cf22b3b85c2a00$export$dbf350e5966cf602 = $06cf22b3b85c2a00$var$_createStrictAPI.css, $06cf22b3b85c2a00$export$eb1ecd84a24ee424 = $06cf22b3b85c2a00$var$_createStrictAPI.cssMap, $06cf22b3b85c2a00$export$a274e22fb40f762e = $06cf22b3b85c2a00$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("1Slnq", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $15db6a98a998cf72$export$39716b4af53f4ad; });

var $bPDhB = parcelRequire("bPDhB");

var $byv0L = parcelRequire("byv0L");
function $15db6a98a998cf72$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $bPDhB.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $bPDhB.createStrictSetupError)();
        },
        cx: $byv0L.cx,
        XCSSProp () {
            throw (0, $bPDhB.createStrictSetupError)();
        }
    };
}

});
parcelRegister("bPDhB", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $89d2ede6e5e212cf$export$c4df1cb0c2b4d77c; });
const $89d2ede6e5e212cf$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $89d2ede6e5e212cf$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});



parcelRegister("hWWFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1155dfe58da5dd1$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");
var $d1155dfe58da5dd1$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $d1155dfe58da5dd1$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $d1155dfe58da5dd1$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $d1155dfe58da5dd1$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $d1155dfe58da5dd1$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $d1155dfe58da5dd1$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $d1155dfe58da5dd1$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $d1155dfe58da5dd1$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $d1155dfe58da5dd1$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $85v1J.default)(_ref, $d1155dfe58da5dd1$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $9RXLj.default)({}, ariaAttributes, {
        role: role,
        className: (0, $cwf3q.default)([
            $d1155dfe58da5dd1$var$styles.root,
            gap && $d1155dfe58da5dd1$var$columnGapMap[gap],
            columnGap && $d1155dfe58da5dd1$var$columnGapMap[columnGap],
            gap && $d1155dfe58da5dd1$var$rowGapMap[gap],
            rowGap && $d1155dfe58da5dd1$var$rowGapMap[rowGap],
            alignItems && $d1155dfe58da5dd1$var$alignItemsMap[alignItems],
            direction && $d1155dfe58da5dd1$var$flexDirectionMap[direction],
            justifyContent && $d1155dfe58da5dd1$var$justifyContentMap[justifyContent],
            wrap && $d1155dfe58da5dd1$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$d1155dfe58da5dd1$var$Flex.displayName = "Flex";
var $d1155dfe58da5dd1$export$2e2bcd8739ae039 = $d1155dfe58da5dd1$var$Flex;

});


parcelRegister("2KsZn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20065d3ce8ed24f6$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");


var $byv0L = parcelRequire("byv0L");

var $7pIsh = parcelRequire("7pIsh");

var $aGSwI = parcelRequire("aGSwI");

var $eiF1T = parcelRequire("eiF1T");

var $6I0p6 = parcelRequire("6I0p6");

var $cOZ5u = parcelRequire("cOZ5u");
var $20065d3ce8ed24f6$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $20065d3ce8ed24f6$var$_excluded2 = [
    "className"
];
var $20065d3ce8ed24f6$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $20065d3ce8ed24f6$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eiF1T.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $85v1J.default)(_ref, $20065d3ce8ed24f6$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $6I0p6.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $7pIsh.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.15.4",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $85v1J.default)(htmlAttributes, $20065d3ce8ed24f6$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $cOZ5u.default), (0, $9RXLj.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $aGSwI.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $byv0L.cx)($20065d3ce8ed24f6$var$styles.root, isDisabled && $20065d3ce8ed24f6$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $20065d3ce8ed24f6$export$2e2bcd8739ae039 = $20065d3ce8ed24f6$var$Pressable;

});
parcelRegister("7pIsh", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $565d5a173fb10a93$export$a4687b0234b40e28; });

var $5itxH = parcelRequire("5itxH");

var $iSvIT = parcelRequire("iSvIT");

var $ehvLk = parcelRequire("ehvLk");

var $2eAha = parcelRequire("2eAha");
function $565d5a173fb10a93$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $565d5a173fb10a93$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $565d5a173fb10a93$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $565d5a173fb10a93$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $565d5a173fb10a93$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $ehvLk.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $2eAha.useTrackedRef)(analyticsData);
    var fnRef = (0, $2eAha.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $565d5a173fb10a93$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("ehvLk", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $a65b4a901d9dc803$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $3G7h5 = parcelRequire("3G7h5");

var $1xcpp = parcelRequire("1xcpp");
function $a65b4a901d9dc803$export$5bf35293e545f20c() {
    var analyticsContext = (0, $1xcpp.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $3G7h5.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("3G7h5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2adaefe61b9803cc$export$2e2bcd8739ae039; });

var $688hO = parcelRequire("688hO");

var $iAnwu = parcelRequire("iAnwu");

var $9P5Ld = parcelRequire("9P5Ld");

var $68nHy = parcelRequire("68nHy");

var $eWqoV = parcelRequire("eWqoV");

var $37meX = parcelRequire("37meX");

var $9cV9f = parcelRequire("9cV9f");

var $5itxH = parcelRequire("5itxH");

var $6Ra3J = parcelRequire("6Ra3J");
function $2adaefe61b9803cc$var$_callSuper(t, o, e) {
    return o = (0, $eWqoV.default)(o), (0, $68nHy.default)(t, $2adaefe61b9803cc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $eWqoV.default)(t).constructor) : o.apply(t, e));
}
function $2adaefe61b9803cc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2adaefe61b9803cc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2adaefe61b9803cc$var$_superPropGet(t, o, e, r) {
    var p = (0, $37meX.default)((0, $eWqoV.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $2adaefe61b9803cc$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2adaefe61b9803cc$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $2adaefe61b9803cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $iAnwu.default)(this, UIAnalyticsEvent);
        _this = $2adaefe61b9803cc$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $5itxH.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $5itxH.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $688hO.default)(_this.context);
            var handlers = (0, $688hO.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $5itxH.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $9cV9f.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $9P5Ld.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $2adaefe61b9803cc$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $6Ra3J.default));

});
parcelRegister("37meX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24534700903f4ac3$export$2e2bcd8739ae039; });

var $gffh5 = parcelRequire("gffh5");
function $24534700903f4ac3$export$2e2bcd8739ae039() {
    return $24534700903f4ac3$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $gffh5.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $24534700903f4ac3$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("gffh5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd39e53fffe7fc19$export$2e2bcd8739ae039; });

var $eWqoV = parcelRequire("eWqoV");
function $bd39e53fffe7fc19$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $eWqoV.default)(t)););
    return t;
}

});


parcelRegister("6Ra3J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fdf7ee20fa22698$export$2e2bcd8739ae039; });

var $6cZa1 = parcelRequire("6cZa1");

var $iAnwu = parcelRequire("iAnwu");

var $9P5Ld = parcelRequire("9P5Ld");

var $5itxH = parcelRequire("5itxH");
function $4fdf7ee20fa22698$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fdf7ee20fa22698$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fdf7ee20fa22698$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fdf7ee20fa22698$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4fdf7ee20fa22698$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $4fdf7ee20fa22698$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $4fdf7ee20fa22698$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $iAnwu.default)(this, AnalyticsEvent);
        (0, $5itxH.default)(this, "_isAnalyticsEvent", true);
        (0, $5itxH.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $4fdf7ee20fa22698$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $9P5Ld.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $6cZa1.default)(updater) === "object") this.payload = $4fdf7ee20fa22698$var$_objectSpread($4fdf7ee20fa22698$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("1xcpp", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $11e27fa1b8b8c9d1$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $11e27fa1b8b8c9d1$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("2eAha", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $1a09073370955489$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $1a09073370955489$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("eiF1T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a69292b799acd49f$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $a69292b799acd49f$export$2e2bcd8739ae039() {}

});

parcelRegister("6I0p6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e272a54b5301b72$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $4e272a54b5301b72$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("cOZ5u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95598a48c29eac98$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $jxLBU = parcelRequire("jxLBU");
var $95598a48c29eac98$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $95598a48c29eac98$var$_excluded2 = [
    "className"
];
var $95598a48c29eac98$var$focusRingStyles = null;
var $95598a48c29eac98$var$insetFocusRingStyles = null;
// This is added to override and reset global styles that apps might be applying - for example,
// at the time of writing, Jira has global styles that targets all button and anchor elements,
// adding an outline on :focus.
var $95598a48c29eac98$var$outlineResetStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $95598a48c29eac98$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $85v1J.default)(_ref, $95598a48c29eac98$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $85v1J.default)(htmlAttributes, $95598a48c29eac98$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $9RXLj.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $cwf3q.default)([
            "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            (0, $jxLBU.fg)("platform_dst_compiled_primitives_outline_reset") && "_ymio1r31 _ypr0glyw _zcxs1o36",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $95598a48c29eac98$export$2e2bcd8739ae039 = $95598a48c29eac98$var$Focusable;

});


parcelRegister("ABMe6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06e0aa9a295dbc74$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cwf3q = parcelRequire("cwf3q");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $hvreB = parcelRequire("hvreB");

var $4ZzO8 = parcelRequire("4ZzO8");
/**
 * Returns the appropriate circle stroke color.
 */ function $06e0aa9a295dbc74$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $hvreB.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $hvreB.N0), ")");
}
var $06e0aa9a295dbc74$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $06e0aa9a295dbc74$var$loadIn = null;
var $06e0aa9a295dbc74$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $06e0aa9a295dbc74$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $06e0aa9a295dbc74$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $4ZzO8.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $06e0aa9a295dbc74$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $06e0aa9a295dbc74$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $cwf3q.default)([
            $06e0aa9a295dbc74$var$styles.wrapperStyles,
            $06e0aa9a295dbc74$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $cwf3q.default)([
            $06e0aa9a295dbc74$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $cwf3q.default)([
            $06e0aa9a295dbc74$var$styles.circleStyles
        ])
    })));
}));
var $06e0aa9a295dbc74$export$2e2bcd8739ae039 = $06e0aa9a295dbc74$var$Spinner;

});
parcelRegister("hvreB", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $cbea75206da5d661$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $cbea75206da5d661$export$c39c0fe0f26207ae; });
// Reds
var $cbea75206da5d661$export$4b84fd0e2c617bd = "#FFEBE6";
var $cbea75206da5d661$export$b34b069eff244586 = "#FFBDAD";
var $cbea75206da5d661$export$be802dd0d8b57f35 = "#FF8F73";
var $cbea75206da5d661$export$60847d42f9da92a6 = "#FF7452";
var $cbea75206da5d661$export$4a7404f376229999 = "#FF5630";
var $cbea75206da5d661$export$2010d0fb4295b346 = "#DE350B";
var $cbea75206da5d661$export$2837b5a1a71d5c02 = "#BF2600";
var $cbea75206da5d661$export$8d9596b529bbb9cf = "#FFFAE6";
var $cbea75206da5d661$export$41060a744ab0b7ae = "#FFF0B3";
var $cbea75206da5d661$export$1cc05bbbf340e559 = "#FFE380";
var $cbea75206da5d661$export$5aae31392d72caaa = "#FFC400";
var $cbea75206da5d661$export$c6930421db9fa514 = "#FFAB00";
var $cbea75206da5d661$export$59619663aa6500fb = "#FF991F";
var $cbea75206da5d661$export$874739ea9e379ab6 = "#FF8B00";
var $cbea75206da5d661$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $cbea75206da5d661$export$69a3bf21b9686c2b = "#ABF5D1";
var $cbea75206da5d661$export$afbce1382ec95f73 = "#79F2C0";
var $cbea75206da5d661$export$747d86715d4175de = "#57D9A3";
var $cbea75206da5d661$export$940e1f69e873f202 = "#36B37E";
var $cbea75206da5d661$export$a49394138f7b8e85 = "#00875A";
var $cbea75206da5d661$export$6fa04827ac68a4fb = "#006644";
var $cbea75206da5d661$export$226de0355ed012f8 = "#DEEBFF";
var $cbea75206da5d661$export$8c13c2ee36917869 = "#B3D4FF";
var $cbea75206da5d661$export$ecfc1dff386a3e7a = "#4C9AFF";
var $cbea75206da5d661$export$215b7063051591f1 = "#2684FF";
var $cbea75206da5d661$export$e62e8919cca44969 = "#0065FF";
var $cbea75206da5d661$export$b3de0ae08da2ce64 = "#0052CC";
var $cbea75206da5d661$export$a6ee3d71bc067634 = "#0747A6";
var $cbea75206da5d661$export$67f15409e87642a1 = "#669DF1";
var $cbea75206da5d661$export$f0539dbc42dbb067 = "#8FB8F6";
var $cbea75206da5d661$export$363e4475840015bb = "#EAE6FF";
var $cbea75206da5d661$export$4b0a4417ed59760f = "#C0B6F2";
var $cbea75206da5d661$export$6011520a64d9a187 = "#998DD9";
var $cbea75206da5d661$export$a7175d4e9206bc80 = "#8777D9";
var $cbea75206da5d661$export$b48405b95304b5a1 = "#6554C0";
var $cbea75206da5d661$export$c71e4279dd54a18d = "#5243AA";
var $cbea75206da5d661$export$147899de772240ec = "#403294";
var $cbea75206da5d661$export$2cf711fe14c66f06 = "#E6FCFF";
var $cbea75206da5d661$export$7a8f4d33f6f9772c = "#B3F5FF";
var $cbea75206da5d661$export$776c9c497ef08533 = "#79E2F2";
var $cbea75206da5d661$export$69cb3ca10c1e330e = "#00C7E6";
var $cbea75206da5d661$export$9dc1ef0f3f48059b = "#00B8D9";
var $cbea75206da5d661$export$7c835c78b6fcdef8 = "#00A3BF";
var $cbea75206da5d661$export$6036577f95c3877e = "#008DA6";
var $cbea75206da5d661$export$29a4f05edc054374 = "#FFFFFF";
var $cbea75206da5d661$export$e655ef011c4aa1a2 = "#FAFBFC";
var $cbea75206da5d661$export$9fdfb749e33cdf97 = "#F4F5F7";
var $cbea75206da5d661$export$3e51e8f1440314ba = "#EBECF0";
var $cbea75206da5d661$export$1ce2d1575d444ceb = "#DFE1E6";
var $cbea75206da5d661$export$8754fc7e6d8b3000 = "#C1C7D0";
var $cbea75206da5d661$export$c2e91cbeada39b8b = "#B3BAC5";
var $cbea75206da5d661$export$5f71e19f3a7ad9de = "#A5ADBA";
var $cbea75206da5d661$export$eaa8c8a70ac22806 = "#97A0AF";
var $cbea75206da5d661$export$7c87d337fb91a97d = "#8993A4";
var $cbea75206da5d661$export$d6447c357493214f = "#7A869A";
var $cbea75206da5d661$export$f563ee71e9ee74cd = "#6B778C";
var $cbea75206da5d661$export$e2ef2124cf4024b1 = "#5E6C84";
var $cbea75206da5d661$export$eece5f492e429f08 = "#505F79";
var $cbea75206da5d661$export$c39c0fe0f26207ae = "#42526E";
var $cbea75206da5d661$export$7090862dc3038a9f = "#344563";
var $cbea75206da5d661$export$ad0bacf983b7ddaa = "#253858";
var $cbea75206da5d661$export$7d61b15e0da132af = "#172B4D";
var $cbea75206da5d661$export$fbda843f0a27fe96 = "#091E42";
var $cbea75206da5d661$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $cbea75206da5d661$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $cbea75206da5d661$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $cbea75206da5d661$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $cbea75206da5d661$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $cbea75206da5d661$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $cbea75206da5d661$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $cbea75206da5d661$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $cbea75206da5d661$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $cbea75206da5d661$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $cbea75206da5d661$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $cbea75206da5d661$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $cbea75206da5d661$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $cbea75206da5d661$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $cbea75206da5d661$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $cbea75206da5d661$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $cbea75206da5d661$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $cbea75206da5d661$export$2f6319cf7d736c2a = "#E6EDFA";
var $cbea75206da5d661$export$95126bc8884d6634 = "#DCE5F5";
var $cbea75206da5d661$export$8338d8c35d44ff1 = "#CED9EB";
var $cbea75206da5d661$export$5368d76ae4fbbda7 = "#B8C7E0";
var $cbea75206da5d661$export$9f0a771d16ec8d36 = "#ABBBD6";
var $cbea75206da5d661$export$abcf8c38338b4aa5 = "#9FB0CC";
var $cbea75206da5d661$export$97e81faa16a182c7 = "#8C9CB8";
var $cbea75206da5d661$export$bfe21c59123ecf33 = "#7988A3";
var $cbea75206da5d661$export$ee82aa2ea6a1558 = "#67758F";
var $cbea75206da5d661$export$682927c6ed76be02 = "#56637A";
var $cbea75206da5d661$export$91fd9994c5be9757 = "#455166";
var $cbea75206da5d661$export$d281fbfe3cff2df6 = "#3B475C";
var $cbea75206da5d661$export$3902c91d8b98a753 = "#313D52";
var $cbea75206da5d661$export$8e8133c1ba5845b5 = "#283447";
var $cbea75206da5d661$export$33ff357f6620b39 = "#202B3D";
var $cbea75206da5d661$export$633847cf062b69e0 = "#1B2638";
var $cbea75206da5d661$export$9776a6e503bdbf76 = "#121A29";
var $cbea75206da5d661$export$6c813d5160dff5db = "#0E1624";
var $cbea75206da5d661$export$3d4f271a500072a = "#0D1424";
var $cbea75206da5d661$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $cbea75206da5d661$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $cbea75206da5d661$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $cbea75206da5d661$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $cbea75206da5d661$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $cbea75206da5d661$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $cbea75206da5d661$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $cbea75206da5d661$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $cbea75206da5d661$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $cbea75206da5d661$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $cbea75206da5d661$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $cbea75206da5d661$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $cbea75206da5d661$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $cbea75206da5d661$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $cbea75206da5d661$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $cbea75206da5d661$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $cbea75206da5d661$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $cbea75206da5d661$export$d2adc5dedf09fced = "#292A2E";
var $cbea75206da5d661$export$f51762073d2bb381 = "#94C748";
var $cbea75206da5d661$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("4ZzO8", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $3a28a29128049381$export$4e9f1640bbe7a1a8; });
var $3a28a29128049381$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("frrXG", function(module, exports) {

$parcel$export(module.exports, "inputCSS", function () { return $b3df113e24555169$export$14a7781d0ca7abea; });
$parcel$export(module.exports, "default", function () { return $b3df113e24555169$export$2e2bcd8739ae039; });
/* input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $jxLBU = parcelRequire("jxLBU");

var $gRzS4 = parcelRequire("gRzS4");
var $b3df113e24555169$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $b3df113e24555169$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $b3df113e24555169$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $b3df113e24555169$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $b3df113e24555169$var$nativeInputStylesOld = null;
var $b3df113e24555169$var$nativeInputStyles = null;
var $b3df113e24555169$var$hidden = null;
var $b3df113e24555169$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $gRzS4.cleanCommonProps)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, $85v1J.default)(_cleanCommonProps, $b3df113e24555169$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "input", {
        "input-container": true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $jxLBU.fg)("platform_do_not_clear_input_for_multiselect")) return /*#__PURE__*/ $iSvIT.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $b3df113e24555169$var$inputStyles.root,
            isDisabled && $b3df113e24555169$var$inputStyles.disabled,
            (0, $byv0L.cx)(className, xcss, "-Input")
        ]),
        "data-value": value || "",
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $iSvIT.createElement("input", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $cwf3q.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, "-input")
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $b3df113e24555169$var$inputStylesOld.root,
            isDisabled && $b3df113e24555169$var$inputStylesOld.disabled,
            (0, $byv0L.cx)(className, xcss, "-Input")
        ]),
        "data-value": value || "",
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $iSvIT.createElement("input", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $cwf3q.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, "-input")
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b3df113e24555169$export$2e2bcd8739ae039 = $b3df113e24555169$var$Input;

});

parcelRegister("fjGa0", function(module, exports) {

$parcel$export(module.exports, "menuCSS", function () { return $b2695587a83b6801$export$a228922d5ca42a79; });
$parcel$export(module.exports, "MenuPlacer", function () { return $b2695587a83b6801$export$f32337f3a7617699; });
$parcel$export(module.exports, "default", function () { return $b2695587a83b6801$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "menuListCSS", function () { return $b2695587a83b6801$export$abafed69cff95d5e; });
$parcel$export(module.exports, "MenuList", function () { return $b2695587a83b6801$export$d4c4e98c5044dc8; });
$parcel$export(module.exports, "noOptionsMessageCSS", function () { return $b2695587a83b6801$export$cf0e22534d8b0074; });
$parcel$export(module.exports, "loadingMessageCSS", function () { return $b2695587a83b6801$export$98ec46397a8cb3cd; });
$parcel$export(module.exports, "NoOptionsMessage", function () { return $b2695587a83b6801$export$d58b72b7d3c4072c; });
$parcel$export(module.exports, "LoadingMessage", function () { return $b2695587a83b6801$export$e928a71d039d3102; });
$parcel$export(module.exports, "menuPortalCSS", function () { return $b2695587a83b6801$export$1dbbeb9648d1fdc9; });
$parcel$export(module.exports, "MenuPortal", function () { return $b2695587a83b6801$export$793392f970497feb; });
/* menu.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $85v1J = parcelRequire("85v1J");

var $9RXLj = parcelRequire("9RXLj");

var $5itxH = parcelRequire("5itxH");

var $Y7EFl = parcelRequire("Y7EFl");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $24DUy = parcelRequire("24DUy");

var $i5UxU = parcelRequire("i5UxU");

var $3fOxZ = parcelRequire("3fOxZ");

var $4Y5Ax = parcelRequire("4Y5Ax");

var $gRzS4 = parcelRequire("gRzS4");
var $b2695587a83b6801$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $b2695587a83b6801$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $b2695587a83b6801$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2695587a83b6801$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2695587a83b6801$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2695587a83b6801$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $b2695587a83b6801$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $gRzS4.getScrollParent)(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $gRzS4.normalizedHeight)(scrollParent);
    var scrollTop = (0, $gRzS4.getScrollTop)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gRzS4.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gRzS4.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) (0, $gRzS4.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gRzS4.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gRzS4.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $b2695587a83b6801$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $b2695587a83b6801$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qsd0yg",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $b2695587a83b6801$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $b2695587a83b6801$var$PortalPlacementContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $b2695587a83b6801$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $iSvIT.useContext)($b2695587a83b6801$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)(maxMenuHeight), _useState2 = (0, $Y7EFl.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(null), _useState4 = (0, $Y7EFl.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $3fOxZ.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $b2695587a83b6801$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $b2695587a83b6801$var$_objectSpread($b2695587a83b6801$var$_objectSpread({}, props), {}, {
            placement: placement || $b2695587a83b6801$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $b2695587a83b6801$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "menu", {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $b2695587a83b6801$var$menuStyles.root,
            $b2695587a83b6801$var$menuStyles[placement],
            (0, $byv0L.cx)(xcss, className, "-menu")
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b2695587a83b6801$export$2e2bcd8739ae039 = $b2695587a83b6801$var$Menu;
var $b2695587a83b6801$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $b2695587a83b6801$var$menuListStyles = null;
var $b2695587a83b6801$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $gRzS4.getStyleProps)(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $byv0L.cx)(className, xcss, "-MenuList")
        ]),
        style: $b2695587a83b6801$var$_objectSpread($b2695587a83b6801$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $b2695587a83b6801$var$noticeCSS = function noticeCSS() {
    return {};
};
var $b2695587a83b6801$var$noticeStyles = null;
var $b2695587a83b6801$export$cf0e22534d8b0074 = $b2695587a83b6801$var$noticeCSS;
var $b2695587a83b6801$export$98ec46397a8cb3cd = $b2695587a83b6801$var$noticeCSS;
var $b2695587a83b6801$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? "No options" : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, $85v1J.default)(_ref3, $b2695587a83b6801$var$_excluded);
    var _getStyleProps3 = (0, $gRzS4.getStyleProps)($b2695587a83b6801$var$_objectSpread($b2695587a83b6801$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $byv0L.cx)(className, xcss, "-NoOptionsMessage")
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $iSvIT.createElement((0, $4Y5Ax.default), {
        color: "color.text.subtle"
    }, children));
};
var $b2695587a83b6801$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? "Loading..." : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, $85v1J.default)(_ref4, $b2695587a83b6801$var$_excluded2);
    var _getStyleProps4 = (0, $gRzS4.getStyleProps)($b2695587a83b6801$var$_objectSpread($b2695587a83b6801$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $byv0L.cx)(className, xcss, "-LoadingMessage")
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $iSvIT.createElement((0, $4Y5Ax.default), {
        color: "color.text.subtle"
    }, children));
};
var $b2695587a83b6801$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $b2695587a83b6801$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $b2695587a83b6801$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $iSvIT.useRef)(null);
    var cleanupRef = (0, $iSvIT.useRef)(null);
    var _useState5 = (0, $iSvIT.useState)($b2695587a83b6801$var$coercePlacement(menuPlacement)), _useState6 = (0, $Y7EFl.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $iSvIT.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $iSvIT.useState)(null), _useState8 = (0, $Y7EFl.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $iSvIT.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $gRzS4.getBoundingClientObj)(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $3fOxZ.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $iSvIT.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $24DUy.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $3fOxZ.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $iSvIT.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    var _getStyleProps5 = (0, $gRzS4.getStyleProps)($b2695587a83b6801$var$_objectSpread($b2695587a83b6801$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $b2695587a83b6801$var$menuPortalStyles.root,
            (0, $byv0L.cx)(className, xcss, "-MenuPortal")
        ]),
        ref: setMenuPortalElement,
        style: $b2695587a83b6801$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            "--menu-left": "".concat(computedPosition.rect.left, "px"),
            "--menu-position": menuPosition,
            "--menu-top": "".concat(computedPosition.offset, "px"),
            "--menu-width": "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $iSvIT.createElement($b2695587a83b6801$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $i5UxU.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("4Y5Ax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39e119c50826e85e$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $jNYFj = parcelRequire("jNYFj");

var $lKfoO = parcelRequire("lKfoO");

var $dDnDD = parcelRequire("dDnDD");
var $39e119c50826e85e$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $39e119c50826e85e$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $dDnDD.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($39e119c50826e85e$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $39e119c50826e85e$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $39e119c50826e85e$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pmoej",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $39e119c50826e85e$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $39e119c50826e85e$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $39e119c50826e85e$var$textColorMap = {
    "color.text": "_syaz1fxt",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syaz1q28",
    "color.text.accent.orange.bolder": "_syaz1vps",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syazpnps",
    "color.text.accent.blue.bolder": "_syazsc1o",
    "color.text.accent.purple": "_syaz10m5",
    "color.text.accent.purple.bolder": "_syaz2ibx",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1dyx",
    "color.text.accent.gray.bolder": "_syaz1x9z",
    "color.text.disabled": "_syaz1lh4",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syazaqb7",
    "color.text.brand": "_syaz1e6v",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syazwx40",
    "color.text.warning.inverse": "_syazal3n",
    "color.text.success": "_syazy73q",
    "color.text.discovery": "_syazzjem",
    "color.text.information": "_syaze0os",
    "color.text.subtlest": "_syaz131l",
    "color.text.subtle": "_syaz1gjq",
    "color.link": "_syaz14q2",
    "color.link.pressed": "_syaz16c2",
    "color.link.visited": "_syazw7te",
    "color.link.visited.pressed": "_syazg3x0"
};
var $39e119c50826e85e$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $39e119c50826e85e$var$Text = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $jNYFj.default)($39e119c50826e85e$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $lKfoO.useHasTextAncestor)();
    var color = $39e119c50826e85e$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        className: (0, $cwf3q.default)([
            $39e119c50826e85e$var$styles.root,
            size && $39e119c50826e85e$var$fontSizeMap[size],
            color && $39e119c50826e85e$var$textColorMap[color],
            maxLines && $39e119c50826e85e$var$styles.truncation,
            maxLines === 1 && $39e119c50826e85e$var$styles.breakAll,
            align && $39e119c50826e85e$var$styles["textAlign.".concat(align)],
            weight && $39e119c50826e85e$var$fontWeightMap[weight],
            Component === "em" && $39e119c50826e85e$var$styles["as.em"],
            Component === "strong" && $39e119c50826e85e$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $iSvIT.createElement((0, $lKfoO.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $39e119c50826e85e$export$2e2bcd8739ae039 = $39e119c50826e85e$var$Text;

});
parcelRegister("lKfoO", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $fd49d6cf50cf3a8a$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $fd49d6cf50cf3a8a$export$ae933c6cbe5643ad; });

var $iSvIT = parcelRequire("iSvIT");
var $fd49d6cf50cf3a8a$var$HasTextAncestorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $fd49d6cf50cf3a8a$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $iSvIT.useContext)($fd49d6cf50cf3a8a$var$HasTextAncestorContext);
};
var $fd49d6cf50cf3a8a$export$ae933c6cbe5643ad = $fd49d6cf50cf3a8a$var$HasTextAncestorContext.Provider;

});

parcelRegister("dDnDD", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $9ed140f9715d0ca0$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $9ed140f9715d0ca0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $9ed140f9715d0ca0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($9ed140f9715d0ca0$export$1ca2a26fecb070ae);
};
$9ed140f9715d0ca0$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("lcn7s", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", function () { return $f6eca6f9e2c883f6$export$23c213f7717186af; });
$parcel$export(module.exports, "multiValueLabelCSS", function () { return $f6eca6f9e2c883f6$export$f40612612e0af964; });
$parcel$export(module.exports, "multiValueRemoveCSS", function () { return $f6eca6f9e2c883f6$export$283467f6c4ac142b; });
$parcel$export(module.exports, "MultiValueContainer", function () { return $f6eca6f9e2c883f6$export$cf9cf2a30a59265c; });
$parcel$export(module.exports, "MultiValueLabel", function () { return $f6eca6f9e2c883f6$export$544aeea2a5ce08ee; });
$parcel$export(module.exports, "MultiValueRemove", function () { return $f6eca6f9e2c883f6$export$8e1fd1a40e7a2f4a; });
$parcel$export(module.exports, "default", function () { return $f6eca6f9e2c883f6$export$2e2bcd8739ae039; });
/* multi-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5itxH = parcelRequire("5itxH");

var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $5Vkr0 = parcelRequire("5Vkr0");

var $eN5I7 = parcelRequire("eN5I7");

var $gRzS4 = parcelRequire("gRzS4");
function $f6eca6f9e2c883f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6eca6f9e2c883f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6eca6f9e2c883f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6eca6f9e2c883f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f6eca6f9e2c883f6$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $f6eca6f9e2c883f6$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $f6eca6f9e2c883f6$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $f6eca6f9e2c883f6$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c82smr _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s"
};
var $f6eca6f9e2c883f6$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $f6eca6f9e2c883f6$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syaz1fxt _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr3166n _13br1jjn _1di61dty _i5f81jjn"
};
var $f6eca6f9e2c883f6$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $f6eca6f9e2c883f6$var$multiValueStyles.root,
            isDisabled && $f6eca6f9e2c883f6$var$multiValueStyles.disabled,
            isFocused && $f6eca6f9e2c883f6$var$multiValueStyles.focused,
            (0, $byv0L.cx)(className, xcss, "-multiValue")
        ])
    }), children);
};
var $f6eca6f9e2c883f6$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $f6eca6f9e2c883f6$var$multiValueLabelStyles.root,
            isDisabled && $f6eca6f9e2c883f6$var$multiValueLabelStyles.disabled,
            hasEllipsis && $f6eca6f9e2c883f6$var$multiValueLabelStyles.ellipsis,
            (0, $byv0L.cx)(className, xcss, "-MultiValueLabel")
        ])
    }), children);
};
var $f6eca6f9e2c883f6$var$disabledStyles = null;
var $f6eca6f9e2c883f6$var$enabledStyles = null;
function $f6eca6f9e2c883f6$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $cwf3q.default)([
            $f6eca6f9e2c883f6$var$multiValueRemoveStyles.root,
            isFocused && $f6eca6f9e2c883f6$var$multiValueRemoveStyles.focused,
            (0, $byv0L.cx)(className, xcss, "-MultiValueRemove")
        ])
    }), /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": isDisabled ? "hide-clear-icon" : "show-clear-icon",
        className: (0, $cwf3q.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Vkr0))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eN5I7))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small",
        size: "small"
    })));
}
var $f6eca6f9e2c883f6$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === "string" ? children : data.label;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "multiValue", {
        "multi-value": true,
        "multi-value--is-disabled": isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $gRzS4.getStyleProps)(props, "multiValueLabel", {
        "multi-value__label": true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $gRzS4.getStyleProps)(props, "multiValueRemove", {
        "multi-value__remove": true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $iSvIT.createElement(Container, {
        data: data,
        innerProps: $f6eca6f9e2c883f6$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $iSvIT.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $iSvIT.createElement(Remove, {
        data: data,
        innerProps: $f6eca6f9e2c883f6$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: "button",
            tabIndex: -1,
            "aria-label": "".concat(ariaLabel || "option", ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f6eca6f9e2c883f6$export$2e2bcd8739ae039 = $f6eca6f9e2c883f6$var$MultiValue;

});
parcelRegister("5Vkr0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $450220817d025fcc$var$_react = $450220817d025fcc$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $450220817d025fcc$var$_baseNew = $450220817d025fcc$var$_interopRequireDefault((parcelRequire("h1I1H")));
function $450220817d025fcc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $450220817d025fcc$var$CrossIcon = (props)=>/*#__PURE__*/ $450220817d025fcc$var$_react.default.createElement($450220817d025fcc$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$450220817d025fcc$var$CrossIcon.displayName = "CrossIcon";
var $450220817d025fcc$var$_default = module.exports.default = $450220817d025fcc$var$CrossIcon;

});


parcelRegister("59Lal", function(module, exports) {

$parcel$export(module.exports, "optionCSS", function () { return $3c12612f7614f154$export$ef897119b7e920ba; });
$parcel$export(module.exports, "default", function () { return $3c12612f7614f154$export$2e2bcd8739ae039; });
/* option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $gRzS4 = parcelRequire("gRzS4");
var $3c12612f7614f154$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $3c12612f7614f154$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk166n _16qsu4to _112e5u6v",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _112e5u6v",
    focusedSelected: "_bfhki1yw"
};
var $3c12612f7614f154$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $3c12612f7614f154$var$optionStyles.root,
            isFocused && $3c12612f7614f154$var$optionStyles.focused,
            isSelected && $3c12612f7614f154$var$optionStyles.selected,
            isFocused && isSelected && $3c12612f7614f154$var$optionStyles.focusedSelected,
            isDisabled && $3c12612f7614f154$var$optionStyles.disabled,
            (0, $byv0L.cx)(className, xcss, "-option")
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3c12612f7614f154$export$2e2bcd8739ae039 = $3c12612f7614f154$var$Option;

});

parcelRegister("eQIBp", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", function () { return $acf8852213f49bb5$export$5f3ffacd6594d90f; });
$parcel$export(module.exports, "default", function () { return $acf8852213f49bb5$export$2e2bcd8739ae039; });
/* placeholder.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $gRzS4 = parcelRequire("gRzS4");
var $acf8852213f49bb5$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $acf8852213f49bb5$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
var $acf8852213f49bb5$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "placeholder", {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $acf8852213f49bb5$var$placeholderStyles.root,
            isDisabled && $acf8852213f49bb5$var$placeholderStyles.disabled,
            (0, $byv0L.cx)(className, xcss, "-placeholder")
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$acf8852213f49bb5$export$2e2bcd8739ae039 = $acf8852213f49bb5$var$Placeholder;

});

parcelRegister("kFLGs", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $f0cca00098c19c42$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $f0cca00098c19c42$export$2e2bcd8739ae039; });
/* single-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $byv0L = parcelRequire("byv0L");

var $gRzS4 = parcelRequire("gRzS4");
var $f0cca00098c19c42$export$dbf350e5966cf602 = function css() {
    return {};
};
var $f0cca00098c19c42$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
var $f0cca00098c19c42$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $gRzS4.getStyleProps)(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $9RXLj.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $cwf3q.default)([
            $f0cca00098c19c42$var$styles.root,
            isDisabled && $f0cca00098c19c42$var$styles.disalbed,
            (0, $byv0L.cx)(className, xcss, "-singleValue")
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f0cca00098c19c42$export$2e2bcd8739ae039 = $f0cca00098c19c42$var$SingleValue;

});


parcelRegister("7WwtK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c8724cf2c72044a$export$2e2bcd8739ae039; });
/* dummy-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $gRzS4 = parcelRequire("gRzS4");
var $5c8724cf2c72044a$var$_excluded = [
    "innerRef"
];
var $5c8724cf2c72044a$var$dummyInputStyles = null;
function $5c8724cf2c72044a$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, $85v1J.default)(_ref, $5c8724cf2c72044a$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $gRzS4.removeProps)(props, "onExited", "in", "enter", "exit", "appear");
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $iSvIT.createElement("input", (0, $9RXLj.default)({
        ref: innerRef,
        className: (0, $cwf3q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

});

parcelRegister("e289l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a37792f25905f1f8$export$2e2bcd8739ae039; });
/* required-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");

var $eiF1T = parcelRequire("eiF1T");
var $a37792f25905f1f8$var$styles = null;
var $a37792f25905f1f8$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $iSvIT.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $cwf3q.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eiF1T.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a37792f25905f1f8$export$2e2bcd8739ae039 = $a37792f25905f1f8$var$RequiredInput;

});

parcelRegister("5QjDl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $441109e20168ed83$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $iwKw8 = parcelRequire("iwKw8");

var $gYM8d = parcelRequire("gYM8d");
var $441109e20168ed83$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $441109e20168ed83$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $iwKw8.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $gYM8d.default)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        onClick: $441109e20168ed83$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: "fixed",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}

});
parcelRegister("iwKw8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7cf4c864b9b1df0$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $gRzS4 = parcelRequire("gRzS4");
var $d7cf4c864b9b1df0$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $d7cf4c864b9b1df0$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $iSvIT.useRef)(false);
    var isTop = (0, $iSvIT.useRef)(false);
    var touchStart = (0, $iSvIT.useRef)(0);
    var scrollTarget = (0, $iSvIT.useRef)(null);
    var handleEventDelta = (0, $iSvIT.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $d7cf4c864b9b1df0$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $iSvIT.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $iSvIT.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $iSvIT.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $iSvIT.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $gRzS4.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("wheel", onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("touchstart", onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $iSvIT.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("wheel", onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("touchstart", onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});

parcelRegister("gYM8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5c795d707b258c7$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $c5c795d707b258c7$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $c5c795d707b258c7$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $c5c795d707b258c7$var$preventTouchMove(e) {
    e.preventDefault();
}
function $c5c795d707b258c7$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $c5c795d707b258c7$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $c5c795d707b258c7$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $c5c795d707b258c7$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $c5c795d707b258c7$var$activeScrollLocks = 0;
var $c5c795d707b258c7$var$listenerOptions = {
    capture: false,
    passive: false
};
function $c5c795d707b258c7$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $iSvIT.useRef)({});
    var scrollTarget = (0, $iSvIT.useRef)(null);
    var addScrollLock = (0, $iSvIT.useCallback)(function(touchScrollTarget) {
        if (!$c5c795d707b258c7$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $c5c795d707b258c7$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $c5c795d707b258c7$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($c5c795d707b258c7$var$LOCK_STYLES).forEach(function(key) {
                var val = $c5c795d707b258c7$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $c5c795d707b258c7$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener("touchmove", $c5c795d707b258c7$var$preventTouchMove, $c5c795d707b258c7$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener("touchstart", $c5c795d707b258c7$var$preventInertiaScroll, $c5c795d707b258c7$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener("touchmove", $c5c795d707b258c7$var$allowTouchMove, $c5c795d707b258c7$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $c5c795d707b258c7$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $iSvIT.useCallback)(function(touchScrollTarget) {
        if (!$c5c795d707b258c7$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $c5c795d707b258c7$var$activeScrollLocks = Math.max($c5c795d707b258c7$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $c5c795d707b258c7$var$activeScrollLocks < 1) $c5c795d707b258c7$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $c5c795d707b258c7$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener("touchmove", $c5c795d707b258c7$var$preventTouchMove, $c5c795d707b258c7$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener("touchstart", $c5c795d707b258c7$var$preventInertiaScroll, $c5c795d707b258c7$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener("touchmove", $c5c795d707b258c7$var$allowTouchMove, $c5c795d707b258c7$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});


parcelRegister("3v0EL", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", function () { return $28c4c6b1db45c946$export$17baa7c95b6ba1b8; });

var $1Z36a = parcelRequire("1Z36a");
function $28c4c6b1db45c946$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $1Z36a.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("hx8bc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc3bdd0d1e3e409d$export$2e2bcd8739ae039; });

var $5itxH = parcelRequire("5itxH");

var $iSvIT = parcelRequire("iSvIT");

var $kdr3s = parcelRequire("kdr3s");

var $io09Z = parcelRequire("io09Z");
function $cc3bdd0d1e3e409d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc3bdd0d1e3e409d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc3bdd0d1e3e409d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc3bdd0d1e3e409d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $cc3bdd0d1e3e409d$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $iSvIT.useMemo)(function() {
        return $cc3bdd0d1e3e409d$var$_objectSpread($cc3bdd0d1e3e409d$var$_objectSpread({}, (0, $kdr3s.defaultAriaLiveMessages)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $iSvIT.useMemo)(function() {
        var message = "";
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return "";
            var onChangeProps = $cc3bdd0d1e3e409d$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $iSvIT.useMemo)(function() {
        var resultsMsg = "";
        if (isLoading) resultsMsg = "Loading. ";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = "No options. ";
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $io09Z.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $io09Z.default), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cc3bdd0d1e3e409d$export$2e2bcd8739ae039 = $cc3bdd0d1e3e409d$var$LiveRegion;

});
parcelRegister("kdr3s", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", function () { return $eb7a02130f7aae70$export$a7265767c78f9bae; });
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ var $eb7a02130f7aae70$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return label.length ? "option ".concat(label, ", deselected") : "";
            case "clear":
                return "All selected options have been cleared.";
            case "select-option":
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : "";
            default:
                return "";
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : "";
    }
};

});

parcelRegister("io09Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62a97abc7b19521$export$2e2bcd8739ae039; });
/* a11y-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9RXLj = parcelRequire("9RXLj");

var $iSvIT = parcelRequire("iSvIT");

var $cwf3q = parcelRequire("cwf3q");
// Assistive text to describe visual elements. Hidden for sighted users.
var $d62a97abc7b19521$var$styles = null;
var $d62a97abc7b19521$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $9RXLj.default)({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $cwf3q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $d62a97abc7b19521$export$2e2bcd8739ae039 = $d62a97abc7b19521$var$A11yText;

});


parcelRegister("asdXs", function(module, exports) {

$parcel$export(module.exports, "createFilter", function () { return $79c758b13ca2a4f1$export$5d81789ff4aeccdf; });

var $5itxH = parcelRequire("5itxH");

var $fV0Sg = parcelRequire("fV0Sg");

var $74vin = parcelRequire("74vin");
function $79c758b13ca2a4f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $79c758b13ca2a4f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $79c758b13ca2a4f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $79c758b13ca2a4f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $79c758b13ca2a4f1$var$memoizedStripDiacriticsForInput = (0, $fV0Sg.default)((0, $74vin.stripDiacritics));
var $79c758b13ca2a4f1$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $79c758b13ca2a4f1$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $79c758b13ca2a4f1$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $79c758b13ca2a4f1$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $79c758b13ca2a4f1$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $79c758b13ca2a4f1$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $79c758b13ca2a4f1$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $79c758b13ca2a4f1$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $74vin.stripDiacritics)(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};

});
parcelRegister("74vin", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", function () { return $52612eb76d540c67$export$b5bee4b27048330b; });
var $52612eb76d540c67$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $52612eb76d540c67$var$anyDiacritic = new RegExp("[" + $52612eb76d540c67$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $52612eb76d540c67$var$diacriticToBase = {};
for(var $52612eb76d540c67$var$i = 0; $52612eb76d540c67$var$i < $52612eb76d540c67$var$diacritics.length; $52612eb76d540c67$var$i++){
    var $52612eb76d540c67$var$diacritic = $52612eb76d540c67$var$diacritics[$52612eb76d540c67$var$i];
    for(var $52612eb76d540c67$var$j = 0; $52612eb76d540c67$var$j < $52612eb76d540c67$var$diacritic.letters.length; $52612eb76d540c67$var$j++)$52612eb76d540c67$var$diacriticToBase[$52612eb76d540c67$var$diacritic.letters[$52612eb76d540c67$var$j]] = $52612eb76d540c67$var$diacritic.base;
}
var $52612eb76d540c67$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($52612eb76d540c67$var$anyDiacritic, function(match) {
        return $52612eb76d540c67$var$diacriticToBase[match];
    });
};

});


parcelRegister("8d2S5", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", function () { return $5fa1c3d69352c8b0$export$214b055320e0bf32; });
$parcel$export(module.exports, "mergeStyles", function () { return $5fa1c3d69352c8b0$export$e618dc39ac9ad607; });

var $5itxH = parcelRequire("5itxH");

var $hmorv = parcelRequire("hmorv");

var $beUig = parcelRequire("beUig");

var $4xLgD = parcelRequire("4xLgD");

var $dnkuV = parcelRequire("dnkuV");

var $frrXG = parcelRequire("frrXG");

var $fjGa0 = parcelRequire("fjGa0");

var $lcn7s = parcelRequire("lcn7s");

var $59Lal = parcelRequire("59Lal");

var $eQIBp = parcelRequire("eQIBp");

var $kFLGs = parcelRequire("kFLGs");
function $5fa1c3d69352c8b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fa1c3d69352c8b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fa1c3d69352c8b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fa1c3d69352c8b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5fa1c3d69352c8b0$export$214b055320e0bf32 = {
    clearIndicator: (0, $dnkuV.clearIndicatorCSS),
    container: (0, $hmorv.containerCSS),
    control: (0, $beUig.css),
    dropdownIndicator: (0, $dnkuV.dropdownIndicatorCSS),
    group: (0, $4xLgD.groupCSS),
    groupHeading: (0, $4xLgD.groupHeadingCSS),
    indicatorsContainer: (0, $hmorv.indicatorsContainerCSS),
    input: (0, $frrXG.inputCSS),
    loadingIndicator: (0, $dnkuV.loadingIndicatorCSS),
    loadingMessage: (0, $fjGa0.loadingMessageCSS),
    menu: (0, $fjGa0.menuCSS),
    menuList: (0, $fjGa0.menuListCSS),
    menuPortal: (0, $fjGa0.menuPortalCSS),
    multiValue: (0, $lcn7s.multiValueCSS),
    multiValueLabel: (0, $lcn7s.multiValueLabelCSS),
    multiValueRemove: (0, $lcn7s.multiValueRemoveCSS),
    noOptionsMessage: (0, $fjGa0.noOptionsMessageCSS),
    option: (0, $59Lal.optionCSS),
    placeholder: (0, $eQIBp.placeholderCSS),
    singleValue: (0, $kFLGs.css),
    valueContainer: (0, $hmorv.valueContainerCSS)
};
function $5fa1c3d69352c8b0$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $5fa1c3d69352c8b0$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("5iIcV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dc0ece565d83d6c$export$2e2bcd8739ae039; });

var $5itxH = parcelRequire("5itxH");

var $Y7EFl = parcelRequire("Y7EFl");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");

var $gRzS4 = parcelRequire("gRzS4");
var $3dc0ece565d83d6c$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $3dc0ece565d83d6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3dc0ece565d83d6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3dc0ece565d83d6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3dc0ece565d83d6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3dc0ece565d83d6c$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $85v1J.default)(_ref, $3dc0ece565d83d6c$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $iSvIT.useRef)(undefined);
    var mounted = (0, $iSvIT.useRef)(false);
    var _useState = (0, $iSvIT.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $Y7EFl.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, $Y7EFl.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(propsDefaultOptions === true), _useState6 = (0, $Y7EFl.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $iSvIT.useState)(undefined), _useState8 = (0, $Y7EFl.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $iSvIT.useState)([]), _useState0 = (0, $Y7EFl.default)(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $iSvIT.useState)(false), _useState10 = (0, $Y7EFl.default)(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $iSvIT.useState)({}), _useState12 = (0, $Y7EFl.default)(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $iSvIT.useState)(undefined), _useState14 = (0, $Y7EFl.default)(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $iSvIT.useState)(undefined), _useState16 = (0, $Y7EFl.default)(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $iSvIT.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $iSvIT.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $iSvIT.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $gRzS4.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $3dc0ece565d83d6c$var$_objectSpread($3dc0ece565d83d6c$var$_objectSpread({}, optionsCache), {}, (0, $5itxH.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $3dc0ece565d83d6c$var$_objectSpread($3dc0ece565d83d6c$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("diw9q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae5e557e826f360$export$2e2bcd8739ae039; });

var $5itxH = parcelRequire("5itxH");

var $Y7EFl = parcelRequire("Y7EFl");

var $85v1J = parcelRequire("85v1J");

var $iSvIT = parcelRequire("iSvIT");
var $9ae5e557e826f360$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9ae5e557e826f360$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ae5e557e826f360$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ae5e557e826f360$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5itxH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ae5e557e826f360$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ae5e557e826f360$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $85v1J.default)(_ref, $9ae5e557e826f360$var$_excluded);
    var _useState = (0, $iSvIT.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $Y7EFl.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $Y7EFl.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $Y7EFl.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $iSvIT.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $iSvIT.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $iSvIT.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $iSvIT.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $9ae5e557e826f360$var$_objectSpread($9ae5e557e826f360$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});



//# sourceMappingURL=datasourceTableView.88216d3e.js.map
